import { render, staticRenderFns } from "./rgbw-control-editor.vue?vue&type=template&id=ce823e20&scoped=true&"
import script from "./rgbw-control-editor.vue?vue&type=script&lang=js&"
export * from "./rgbw-control-editor.vue?vue&type=script&lang=js&"
import style0 from "./rgbw-control-editor.vue?vue&type=style&index=0&id=ce823e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce823e20",
  null
  
)

export default component.exports